import HomePage from "./components/homePage/HomePage";
import CaseA from "./components/case/CaseA";
import CaseB from "./components/case/CaseB";
import CaseC from "./components/case/CaseC";
import Story from "./components/story/Story";

const Routes = [
  {
    path: "/",
    component: HomePage,
    text: '最重要的乘客',
    exact: true
  },
  {
    path: "/story/",
    component: Story,
    text: 'LAND CRUISER品牌故事'
  },
  {
    path: '/kestrel/',
    component: CaseA,
    text: '紅隼'
  },
  {
    path: '/formosan-masked-civet/',
    component: CaseB,
    text: '白鼻心'
  },
  {
    path: '/ruddy-kingfisher/',
    component: CaseC,
    text: '赤翡翠'
  }
];

export default Routes;